module.exports = "<div class=\"header\">\r\n\r\n  <div class=\"logo is-uppercase\"></div>\r\n\r\n  <nav class=\"nav\">\r\n    <a routerLink=\"/\">Início</a>\r\n    <a routerLink=\"/sobre\">Sobre nós</a>\r\n    <a routerLink=\"/produtos\">Produtos</a>\r\n    <a routerLink=\"/contato\">Contato</a>\r\n  </nav>\r\n\r\n<div class=\"burger-menu is-clickable\">\r\n  <div class=\"bar\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/corpo-leve-www/www/src/app/elements/header/header.component.html
// module id = ../../../../../src/app/elements/header/header.component.html
// module chunks = main